import React, { PropsWithChildren } from 'react';
import { FeatureExplanationBlock } from '@models/feature-explanation';

interface ColoredExplanationBlockProps {
  block: FeatureExplanationBlock;
}

export const ColoredExplanationBlock: React.FC<
  PropsWithChildren<ColoredExplanationBlockProps>
> = ({ block, children }) => {
  let color = 'revert';
  let fontWeight = '400';

  if (block.type === FeatureExplanationBlock.Type.DataSlot) {
    color = 'var(--c-blue-700)';
    fontWeight = '500';
  } else if (
    block.type === FeatureExplanationBlock.Type.Column ||
    block.type === FeatureExplanationBlock.Type.PredictionExecutionTime
  ) {
    const pathType = block.pathType as FeatureExplanationBlock.Type;
    if (
      [
        FeatureExplanationBlock.Type.Filter,
        FeatureExplanationBlock.Type.Reduce,
      ].includes(pathType)
    ) {
      color = 'var(--c-blue-700)';
      fontWeight = '500';
    }
  }

  return <span style={{ color, fontWeight }}>{children}</span>;
};
